import React from "react";
import { type DriversListFiltersFormValues } from "./DriversListFiltersForm";
import DriversListFiltersForm from "./DriversListFiltersForm";
import { type FilterType } from "../../models/app/admin/filter";
import { useLocation } from "react-router-dom";
import { driverPageLocation } from "../../utils/driverPageLocation";
import { driverListFiltersDefaultValues } from "./DriversListFiltersForm/driversListFiltersDefaultValues";

type DriversListFiltersModalProps = {
    isEditingFilter: boolean;
    selectedFilter?: DriversListFiltersFormValues;
    onSaveFilter: (value: DriversListFiltersFormValues) => void;
    handleCloseEditDialog: () => void;
    isApplyingFilter: boolean;
    appliedFilter: FilterType;
};

const DriversListFiltersModal: React.FC<DriversListFiltersModalProps> = ({
    isEditingFilter,
    selectedFilter,
    onSaveFilter,
    handleCloseEditDialog,
    isApplyingFilter,
    appliedFilter,
}) => {
    //tells us whether to use temporarily stored data or locally stored data
    const pageLocation = useLocation();
    const location = driverPageLocation(pageLocation.pathname);
    const isEditValues =
        appliedFilter.filterFields ?? driverListFiltersDefaultValues(location);
    const prefilledFormValues = isEditingFilter ? isEditValues : selectedFilter;

    return (
        <>
            <div>
                <DriversListFiltersForm
                    filterValues={prefilledFormValues}
                    handleCloseEditDialog={handleCloseEditDialog}
                    isApplyingFilter={isApplyingFilter}
                    onSaveFilter={onSaveFilter}
                />
            </div>
        </>
    );
};

export default DriversListFiltersModal;
